export default "__VITE_ASSET__DIngQ90X__"